/**
 * Fiscal-transaction feedback toasts — Feb 2026 UX spec.
 *
 * The operator only needs a *single* visual signal after a payment:
 *   • Big green tick  → πώληση επιτυχής
 *   • Big red cross   → κάτι πήγε στραβά
 *
 * FText result codes, driver descriptions and other technical noise
 * are deliberately hidden — they belong in the History/Log screen,
 * not on the front counter while a customer is waiting.
 */
import React from "react";
import { toast } from "sonner";
import { CheckCircle2, XCircle } from "lucide-react";

const BADGE = "grid place-items-center rounded-2xl shadow-2xl w-32 h-32";

function OkBadge() {
  return (
    <div
      data-testid="fiscal-toast-ok"
      className={`${BADGE} bg-gradient-to-br from-emerald-500 to-emerald-600 animate-in zoom-in-95 duration-200`}
    >
      <CheckCircle2 size={80} strokeWidth={2.5} className="text-white drop-shadow" />
    </div>
  );
}

function FailBadge() {
  return (
    <div
      data-testid="fiscal-toast-fail"
      className={`${BADGE} bg-gradient-to-br from-rose-500 to-rose-700 animate-in zoom-in-95 duration-200`}
    >
      <XCircle size={80} strokeWidth={2.5} className="text-white drop-shadow" />
    </div>
  );
}

export function toastFiscalOk() {
  toast.custom(() => <OkBadge />, {
    duration: 1400,
    position: "top-center",
    unstyled: true,
  });
}

export function toastFiscalFail() {
  toast.custom(() => <FailBadge />, {
    duration: 2000,
    position: "top-center",
    unstyled: true,
  });
}
